import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  header: 'Pausar nuevos pedidos',
  sections: {
    pause_orders: {
      title: '¿Cuánto tiempo estarás no disponible?',
      description: 'Informaremos a los clientes de que no estás aceptando nuevos pedidos',
    },
    order_methods: {
      title: 'Mis métodos de pedido',
      description: 'Activa o desactiva los métodos con los que tus clientes pueden pedirte',
    },
    delivery_mode: {
      title: 'Métodos de entrega',
      description: 'Cambia entre tu red de repartidores y la nuestra',
    },
  },
  form: {
    orders_paused_until: {
      options: {
        '10_min': '10 min',
        '15_min': '15 min',
        '20_min': '20 min',
        '25_min': '25 min',
        '1_hour': '1 hora',
        '2_hours': '2 horas',
        rest_of_day: 'Resto del día',
      },
    },
    has_standalone_delivery: {
      label: 'Mis repartidores',
    },
    has_external_delivery: {
      label: 'Red de repartidores {{provider}}',
    },
  },
  labels: {
    delivery_orders_off: 'Pedidos a domicilio desactivados',
    delivery_orders_on: 'Pedidos a domicilio activados',
  },
  modals: {
    toggle_delivery: {
      [true]: {
        title: '¿Seguro que quieres activar los pedidos a domicilio?',
        description: '',
      },
      [false]: {
        title: '¿Seguro que quieres desactivar los pedidos a domicilio?',
        description: '',
      },
    },
    switch_delivery_mode: {
      [DeliveryMode.Internal]: {
        title: '¿Seguro que quieres cambiar a tus repartidores?',
        description: '',
      },
      [DeliveryMode.External]: {
        title: '¿Seguro que quieres cambiar a los repartidores de {{provider}}?',
        description: '',
      },
    },
  },
  buttons: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados correctamente',
  },
};
